<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { storePlenaries, storePlenariesError } from "../scripts/plenary";
    import { getPlenaries } from '../scripts/apiPlenaries';
    import { addNotificationError }  from "../scripts/toaster";
    import { storeUserLogin, storeIsLogin } from '../scripts/user';
    import { redirectTo } from '../scripts/router1';
    import { idPageLogin, idPageNosLivrables } from '../scripts/router2';
    import { addNotificationWarning }  from "../scripts/toaster";
    import Plenary from '../components/Plenary.svelte';
    import { storeLanguage, lang_fr } from "../scripts/store";

    onMount(async () => {
        if (!$storeIsLogin) {
            redirectTo(idPageNosLivrables);
            if ($storeLanguage == $lang_fr) {
                addNotificationWarning("Pour accéder aux plénières <br>vous devez être connecté en tant que membre");
            } else {
                addNotificationWarning("To access the plenaries <br>you must be logged in as a member");
            }
        } else if ($storeUserLogin.user_type != 2 && $storeUserLogin.user_type != 1) {
            if ($storeLanguage == $lang_fr) {
                addNotificationWarning("Pour accéder aux plénières <br>vous devez être connecté en tant que membre");
            } else {
                addNotificationWarning("To access the plenaries <br>you must be logged in as a member");
            }
            redirectTo(idPageNosLivrables);
        } else {
            getPlenariesIfEmpty();
        }
        window.scrollTo(0,0);
	});

    /**
     * getPlenariesIfEmpty
     */
     function getPlenariesIfEmpty() {
        if ($storePlenaries.length <= 0) {
            const returnValue = getPlenaries();
            returnValue.then((data) => {
                if (!data) {
                    addNotificationError($storePlenariesError);
                };
            });
        }
    }

</script>
    
<style lang="scss">

    .plenaries {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__items {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 0 32px;
            width: 100%;
        }
    }

    @include large {
    }

</style>

<div class="plenaries">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="Plénières"/>
    {:else}
    <PageHeader props="Plenaries"/>
    {/if}
    <div class="bloc plenaries__bloc">
        <div class="plenaries__title font__h3">
            {#if ($storeLanguage == $lang_fr)}
            Retrouvez ci-dessous l’ensemble des plénières du collectif
            {:else}
            Find below all the plenaries of the collective
            {/if}
        </div>
        <div class="plenaries__items">
            {#each $storePlenaries as plenary, i}
                <Plenary props={plenary} />
            {/each}
        </div>    
    </div>
</div>
